import { ProfileSwitchHandoff } from '@/components/shared/components/ProfileSwitchOverlay/types/ProfileSwitchHandoff';

const STORAGE_KEY = 'profile_switch_handoff';

export const PROFILE_SWITCH_HANDOFF_TTL_MS = 15_000;

export const clearProfileSwitchHandoff = (): void => {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {}
};

export const saveProfileSwitchHandoff = (handoff: Omit<ProfileSwitchHandoff, 'timestamp'>): void => {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ ...handoff, timestamp: Date.now() }));
  } catch (error) {
    console.error('Could not save the profile switch handoff', error);
  }
};
